export default "__VITE_ASSET__CO$y5_0Y__"